module.exports = "<div class=\"wrap-lienzo\">\r\n  <div class=\"lienzo\">\r\n    <div class=\"columna\">\r\n      <h1>404 no encontrado!</h1>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/404/error.template.html
// module id = ./src/app/404/error.template.html
// module chunks = main